<template>
  <el-dialog
    center
    width="600px"
    title="编辑排序"
    :visible.sync="dialogFormVisible"
  >
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <el-form-item label="排序" :label-width="formLabelWidth" prop="sortIndex">
        <el-input
          type="number"
          v-model="editForm.sortIndex"
          placeholder="请输入排序"
          min="1"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { editSortApi } from '@/api/areaApi.js';
export default {
  name: 'editCity',
  data() {
    return {
      formLabelWidth: '122px', // 对话框中 文本的尺寸
      dialogFormVisible: false, // 是否显示对话框
      editForm: {
        areaId: '',
        sortIndex: '',
      }, // 编辑表单数据

      editRules: {
        sortIndex: [
          { required: true, message: '排列序号不能为空', trigger: 'blur' },
        ],
      }, // 表单的验证规则
      checkAreaLength: 0, // 选中编辑城市的长度，若大于1提示用户只能编辑一条
    };
  },
  computed: {},
  methods: {
    async submitEdit() {
      try {
        if (this.editForm === {})
          return this.$message.error('请选择要编辑的对象');
        this.$refs.editForm.validate(async (valid) => {
          if (!valid) return this.$message.error('格式不对哦，检查一下呗!');
          let res = await editSortApi({ ...this.editForm });
          if (res.code != 200) return;
          this.$message.success('修改成功!');
          this.dialogFormVisible = false;
          this.$emit('handleFresh');
        });
      } catch (e) {
        window.console.log(e);
      }
    },
  },
};
</script>

<style lang="less" sconped>
.tooBox {
  display: flex;
}
</style>
